import React from "react";
import { useTranslation } from "react-i18next";

import Spinner from "../../Components/Spinner";
import { ToastComponent } from "../../Components/ToastComponent";
import {
  useCustomerForm,
  YES_NO,
  DISABLED_FIELD_HEIGHT,
} from "../hooks/useCustomerForm";

export default function AdministrativeData(props) {
  const { t } = useTranslation();
  const internalForm = useCustomerForm(props);
  const form = props.customerForm || internalForm;

  const {
    creditAnalysis,
    setCreditAnalysis,
    dda,
    setDda,
    installmentBooklet,
    setInstallmentBooklet,
    restrictionType,
    setRestrictionType,
    restrictionStartDate,
    setRestrictionStartDate,
    restrictionEndDate,
    setRestrictionEndDate,
    lastSuspensionDate,
    isLoadingClient,
    isSaving,
    toastParams,
    setToastParams,
    restrictions,
    isLoadingRestrictions,
    restrictionsError,
    handleSave,
    handleBillingClick,
  } = form;

  return (
    <div className="p-3">
      <ToastComponent
        params={toastParams}
        closeToast={() => setToastParams(JSON.stringify({ show: false }))}
      />

      <div className="card mb-4">
        <div className="card-header">
          <strong>{t("CUSTOMER.PERSONAL_DATA.SECTION_FINANCIAL")}</strong>
        </div>
        <div className="card-body">
          <div className="row g-3">
            <div className="col-md-4">
              <label className="form-label">
                {t("CUSTOMER.PERSONAL_DATA.CREDIT_ANALYSIS")}
              </label>
              <select
                className="form-select"
                value={creditAnalysis}
                onChange={(e) => setCreditAnalysis(e.target.value)}
                disabled={isLoadingClient}
              >
                <option value="">
                  {t("CUSTOMER.PERSONAL_DATA.SELECT_PLACEHOLDER")}
                </option>
                <option value={YES_NO.YES}>
                  {t("CUSTOMER.PERSONAL_DATA.CREDIT_ANALYSIS_APPROVED")}
                </option>
                <option value={YES_NO.NO}>
                  {t("CUSTOMER.PERSONAL_DATA.CREDIT_ANALYSIS_REJECTED")}
                </option>
              </select>
            </div>
            <div className="col-md-4">
              <label className="form-label">
                {t("CUSTOMER.PERSONAL_DATA.DDA")}
              </label>
              <select
                className="form-select"
                value={dda}
                onChange={(e) => setDda(e.target.value)}
                disabled={isLoadingClient}
              >
                <option value="">
                  {t("CUSTOMER.PERSONAL_DATA.SELECT_PLACEHOLDER")}
                </option>
                <option value={YES_NO.YES}>{t("COMMON.YES")}</option>
                <option value={YES_NO.NO}>{t("COMMON.NO")}</option>
              </select>
            </div>
            <div className="col-md-4">
              <label className="form-label">
                {t("CUSTOMER.PERSONAL_DATA.INSTALLMENT_BOOKLET")}
              </label>
              <select
                className="form-select"
                value={installmentBooklet}
                onChange={(e) => setInstallmentBooklet(e.target.value)}
                disabled={isLoadingClient}
              >
                <option value="">
                  {t("CUSTOMER.PERSONAL_DATA.SELECT_PLACEHOLDER")}
                </option>
                <option value={YES_NO.YES}>{t("COMMON.YES")}</option>
                <option value={YES_NO.NO}>{t("COMMON.NO")}</option>
              </select>
            </div>
          </div>

          <div className="d-flex justify-content-end mt-3">
            <button
              type="button"
              className="btn btn-primary"
              onClick={handleBillingClick}
            >
              {t("CUSTOMER.PERSONAL_DATA.BILLING_BUTTON")}
            </button>
          </div>
        </div>
      </div>

      <div className="card mb-4">
        <div className="card-header">
          <strong>{t("CUSTOMER.PERSONAL_DATA.SECTION_RESTRICTION")}</strong>
        </div>
        <div className="card-body">
          <div className="row g-3">
            <div className="col-md-4">
              <label className="form-label">
                {t("CUSTOMER.PERSONAL_DATA.RESTRICTION_TYPE")}
              </label>
              {isLoadingRestrictions ? (
                <Spinner />
              ) : (
                <select
                  className="form-select"
                  value={restrictionType}
                  onChange={(e) => setRestrictionType(e.target.value)}
                  disabled={restrictionsError}
                >
                  <option value="">
                    {t("CUSTOMER.PERSONAL_DATA.SELECT_PLACEHOLDER")}
                  </option>
                  {restrictions.map((item) => (
                    <option key={item.id} value={item.id}>
                      {item.description}
                    </option>
                  ))}
                </select>
              )}
              {restrictionsError && (
                <small className="text-danger d-block mt-1">
                  {t("CUSTOMER.PERSONAL_DATA.LOAD_RESTRICTIONS_ERROR")}
                </small>
              )}
            </div>
            <div className="col-md-3">
              <label className="form-label">
                {t("CUSTOMER.PERSONAL_DATA.RESTRICTION_START_DATE")}
              </label>
              <input
                type="date"
                className="form-control"
                value={
                  restrictionStartDate ? restrictionStartDate.slice(0, 10) : ""
                }
                onChange={(e) => setRestrictionStartDate(e.target.value)}
                disabled={isLoadingClient}
              />
            </div>
            <div className="col-md-3">
              <label className="form-label">
                {t("CUSTOMER.PERSONAL_DATA.RESTRICTION_END_DATE")}
              </label>
              <input
                type="date"
                className="form-control"
                value={
                  restrictionEndDate ? restrictionEndDate.slice(0, 10) : ""
                }
                onChange={(e) => setRestrictionEndDate(e.target.value)}
                disabled={isLoadingClient}
              />
            </div>
            <div className="col-md-2">
              <label className="form-label">
                {t("CUSTOMER.PERSONAL_DATA.LAST_SUSPENSION_DATE")}
              </label>
              <input
                type="text"
                className="form-control"
                style={DISABLED_FIELD_HEIGHT}
                value={
                  lastSuspensionDate
                    ? new Date(lastSuspensionDate).toLocaleDateString("pt-BR")
                    : ""
                }
                disabled
              />
            </div>
          </div>
        </div>
      </div>

      <div className="d-flex justify-content-end">
        <button
          type="button"
          className="btn btn-primary"
          onClick={handleSave}
          disabled={isSaving}
        >
          {isSaving ? t("CUSTOMER.PERSONAL_DATA.UPDATING") : t("COMMON.SAVE")}
        </button>
      </div>
    </div>
  );
}
    